export default __webpack_public_path__ + "static/media/nft-picture.be5dd913.png";